import { CON_EDISON_HOSTING_MAP_URL } from "app/frontend/constants/external_urls";
import { ROUTES } from "app/frontend/constants/routes";

export const CARDS = [
    {
        title: "Check your DAC Program Eligibility",
        alt: "A map of NYC showing DAC areas.",
        body: "Projects located in Disadvantaged Communities may be eligible for additional customer-side cost incentives.",
        image: "/images/nyc-map.png",
        imagePosition: "center" as const,
        action: {
            text: "Check Eligibility",
            href: ROUTES.DacScreenerPage,
        },
        sx: {
            minWidth: "260px",
        },
    },
    {
        title: "Check Our Hosting Capacity Map",
        alt: "A map of NYC showing ConEd hosting capacity.",
        body: "Use our interactive map to check if Con Edison can support your project by identifying Distributed Energy Resources (DER) locations and guiding interconnection decisions.",
        image: "/images/hosting-map.png",
        imagePosition: "bottom" as const,
        action: {
            text: "View Map",
            href: CON_EDISON_HOSTING_MAP_URL,
        },
        sx: {
            minWidth: "260px",
        },
    },
    {
        title: "Access the Ultimate Knowledge Base",
        alt: "A woman wearing a hardhat.",
        body: "All the resources you need to power your projects in one place.",
        image: "/images/hardhat-person.jpg",
        imagePosition: "top" as const,
        action: {
            text: "Visit Resource Center",
            href: ROUTES.ResourceCenter,
        },
        sx: {
            minWidth: "260px",
        },
    },
];
